var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocentes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 32.4585V40.3751M42.5102 24.5418C41.4133 24.0211 40.2142 23.751 39 23.751C37.7857 23.751 36.5867 24.0211 35.4897 24.5418L24.8956 29.5087C22.5903 30.5886 22.5903 34.3284 24.8956 35.4082L35.4881 40.3751C36.5853 40.8961 37.7846 41.1664 38.9992 41.1664C40.2137 41.1664 41.4131 40.8961 42.5102 40.3751L53.1043 35.4082C55.4096 34.3284 55.4096 30.5886 53.1043 29.5087L42.5102 24.5418Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9166 37.2085V45.3231C27.9166 49.9432 35.3488 52.2502 39 52.2502C42.6511 52.2502 50.0833 49.9432 50.0833 45.3231V37.2085",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocentes);
export default __webpack_public_path__ + "static/media/ic_docentes.c3e1ce6fa65a4e764b04fe551e8fad8c.svg";
export { ForwardRef as ReactComponent };